<template>
  <div class="foot-container">
    <div class='content'>
      <div class='foot-logo'>
        <img :src="footImg"
             alt="">
        <ul>
          <a class='logo-item'
             :href="isShowFootTxt?url.ios_url:url_2.ios_url">
            <img :src="apple"
                 alt="">
            <span>AppStore</span>
          </a>
          <a class='logo-item' v-if="isShowFootTxt"
             :href="isShowFootTxt?url.android_url:url_2.android_url">
            <img :src="android"
                 alt="">
            <span>Android</span>
          </a>
          <a class='logo-item'
             :href="isShowFootTxt?url.google_url:url_2.google_url">
            <img :src="google"
                 alt="">
            <span>Google</span>
          </a>
          <a class='logo-item' href="" style="opacity: 0;" v-if="!isShowFootTxt">
          </a>
        </ul>
      </div>
      <div class='foot-content' v-if="isShowFootTxt">
        <ul class='foot-txt'>
          <li><a href="/help.html">{{$t('foot.HelpCenter')}}</a></li>
          <li> <a target='_blank'
               :href="goLinkUrl['rule_privacy'][goLinkeKey]+'?locale='+goLang+'&fromPage='+goLinkeKey">{{$t('foot.PrivacyPolicy')}}</a></li>
          <li> <a :href="goLinkUrl['auto_extend_agreement'][goLinkeKey]+'?fromPage='+this.goLinkeKey"
               target='_blank'>{{$t('foot.ServiceAgreement')}}</a> </li>
          <li> <a href="/about-us.html">{{$t('foot.CompanyProfile')}}</a> </li>
          <li> <a href="/about-us.html#join">{{$t('foot.JoinUs')}}</a> </li>
          <li> <a href="/about-us.html#contact">{{$t('foot.contactUs')}}</a> </li>
        </ul>
        <ul class='foot-record'>
          <li>
            {{$t('foot.ServiceTel')}}：{{ isShowFootTxt?'0779 - 2681747':'0763 - 3664162' }}<span></span> {{$t('foot.ReportPhone')}}：{{ isShowFootTxt?'0779 - 2681747':'0763 - 3664162' }} <span></span><br/>
            {{$t('foot.ReportEmail')}}： <a href="mailto:cs@lespark.us">cs@lespark.us</a>
          </li>
          <li>
            <a :href="isShowFootTxt?lestoryLink:lesparkLink"><img :src="policeImg" alt=""/></a>
            <a :href="isShowFootTxt?lestoryLink:lesparkLink"> {{ isShowFootTxt?$t('foot2.content1'):$t('foot.content1') }}</a>
            <a href="https://beian.miit.gov.cn">{{ isShowFootTxt?$t('foot2.content2'):$t('foot.content2') }}</a>
            <span v-if="isShowFootTxt">{{$t('foot2.content6')}}</span>
<!--            {{ isShowFootTxt?$t('foot2.content6'):$t('foot.content6')  }}-->
          </li>
          <li>{{ isShowFootTxt?$t('foot2.content3'):$t('foot.content3') }}</li>
        </ul>
      </div>
      <div v-else class='foot-content'>
        <ul class='foot-txt'>
          <li><a href="/help.html">{{$t('foot.HelpCenter')}}</a></li>
          <li> <a :href="goLinkUrl['auto_extend_agreement'][goLinkeKey]+'?fromPage='+this.goLinkeKey"
                  target='_blank'>{{$t('foot.ServiceAgreement')}}</a> </li>
          <li> <a href="/about-us.html">{{$t('foot.CompanyProfile')}}</a> </li>
          <li> <a href="/about-us.html#join">{{$t('foot.JoinUs')}}</a> </li>
          <li> <a href="/about-us.html#contact">{{$t('foot.contactUs')}}</a> </li>
        </ul>
        <ul class='foot-record'>
          <li>
	          Email: <a href="mailto:cs@lespark.us">cs@lespark.us</a>
          </li>
          <li>
            ORIENT BASIC SCIENCE AND TECHNOLOGY PTE. LTD.
          </li>
	        <li>
		        Address: 112 ROBINSON ROAD #03-01ROBINSON 112 SINGAPORE(068902)
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import bus from 'Common/events-bus';
import constans from "Constans";
import util from 'Common/util';

export default {
  name: 'myFooter',
  data () {
    return {
      logoimg: 'https://static.lespark.cn/pc_img/images/logo.png',
      apple: 'https://static.lespark.cn/pc_img/images/apple.png',
      android: 'https://static.lespark.cn/pc_img/images/android.png',
      google: 'https://static.lespark.cn/pc_img/images/Google.png',
      footImg: 'https://static.lespark.cn/pc_img/images/logo-les.png',
      policeImg: 'https://static.lespark.cn/pc_img/images/icon_police.png',
      url: {
        'android_url': "https://dl.lespark.cn/lespark_android/LesPark-release.apk",
        'google_url': "https://play.google.com/store/apps/details?id=com.redwolfama.peonylespark.gp",
        'ios_url': "https://itunes.apple.com/cn/app/id1329843362?mt=8",
      },
      url_2:{
        'android_url': "https://dl.lespark.cn/lespark_android/LesPark-release.apk",
        'google_url': "https://lespark.onelink.me/DPjM/bi0y8b09",
        'ios_url': "https://lespark.onelink.me/sRtA/2saczuub",
      },
      enCenter:false,
      isShowFootTxt:true,
      lesparkLink:'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44180202000386',
      lestoryLink:'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=45050302000153',
      goLinkUrl:constans.UrlLink.goLink.foot,
      goLinkeKey:constans.UrlLink.getUrlKey(),
      goLang:'CN',
    }
  },
  created () {
	  const that = this
    if(window.location.host.includes('lespark.us')){
      this.isShowFootTxt = false
    }else{
      this.isShowFootTxt = true
    }

    let _arg = util.getQueryStringArgs();
    if (_arg.lang == 'zh-Hans-TW') {
      that.goLang = 'TW'
    } else if (_arg.lang == 'zh-Hant-TW') {
      that.goLang = 'CN'
    } else if (_arg.lang == 'en') {
      that.goLang = 'US'
    } else {
      that.goLang = 'US'
    }
  },
  mounted () {
    const that = this
    bus.$on('url', function (msg) {
      let url = {}
      url = msg
      if (url != '') {
        that.url = msg
      }
    })
  },
  methods: {

  }
}
</script>
<style type="text/css" scoped>
.foot-container {
  width: 100%;
  height: 466px;
  background: #f7f7f7;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content {
  max-width: 1400px;
  min-width: 960px;
  width: 90%;
  display: flex;
  justify-content: space-between;
}

.foot-logo {
  height: 135px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}

.foot-logo>img {
  height: 64px;
  width: 194px;
}

.foot-logo>ul {
  width: 460px;
  display: flex;
  justify-content: space-between;
}

.logo-item {
  width: 134px;
  height: 46px;
  background: #000100;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.logo-item>img {
  width: 20px;
  height: 20px;
  margin-right: 12px;
  justify-content: center;
  align-items: center;
}

.foot-content {
  width: 660px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}

.foot-txt {
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000100;
}

.foot-record {
  margin-top: 25px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}

.foot-record>li {
  margin-bottom: 10px;
  text-align: center;
}

.foot-record>li img {
  width: 20px;
  cursor: pointer;
  position: relative;
  top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/components/foot.vue